import { SEV, STATUS } from "../lib/summary";

export const SevBadge = ({ sev, testid, solid = false }) => {
  const m = SEV[sev] || SEV.OBSERVATION;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded border px-2 py-0.5 font-mono text-[10px] font-bold uppercase tracking-wider ${solid ? m.solid : m.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${solid ? "bg-white" : m.dot}`} />
      {m.label}
    </span>
  );
};

export const StatusBadge = ({ status, testid }) => {
  const m = STATUS[status] || STATUS.scheduled;
  return <span data-testid={testid} className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-semibold ${m.cls}`}>{m.label}</span>;
};

export const Stat = ({ label, value, sub, testid, accent }) => (
  <div data-testid={testid} className="rounded-lg border border-slate-200 bg-white p-4 sm:p-5">
    <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">{label}</div>
    <div className={`mt-2 font-display text-2xl sm:text-3xl font-extrabold ${accent || "text-slate-900"}`}>{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </div>
);

export const ScoreRing = ({ score, size = 132, testid }) => {
  const r = 52, c = 2 * Math.PI * r;
  const col = score >= 85 ? "#059669" : score >= 70 ? "#0D9488" : score >= 55 ? "#D97706" : "#DC2626";
  return (
    <div data-testid={testid} className="relative" style={{ width: size, height: size }}>
      <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90">
        <circle cx="60" cy="60" r={r} stroke="#E2E8F0" strokeWidth="10" fill="none" />
        <circle cx="60" cy="60" r={r} stroke={col} strokeWidth="10" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (c * (score || 0)) / 100} style={{ transition: "stroke-dashoffset 1s ease" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <div>
          <div className="font-display text-4xl font-extrabold leading-none">{score ?? "-"}</div>
          <div className="font-mono text-[10px] text-slate-500 mt-1">/ 100</div>
        </div>
      </div>
    </div>
  );
};

export const PageHead = ({ over, title, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-6">
    <div>
      {over && <div className="overline mb-2">{over}</div>}
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
